import React from 'react';
import { isEmpty } from 'lodash';
import styles from './index.module.css';
import { Card, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

// @component
import Azure from '@/components/CloudAccounts/EditCloudAccountV2/Azure';
import GCP from '@/components/CloudAccounts/EditCloudAccountV2/GCP';
import BasicAWSOverview from './BasicAWSOverview';
import AdvancedAWSOverView from './AdvancedAWSOverView';
import StacksetPage from '../StacksetPage';
import BasicGCPOverview from './BasicGCPOverview';
import BasicAzureOverview from './BasicAzureOverview';
import AdvancedGCPOverview from './AdvancedGCPOverview';
import AdvancedAzureOverview from './AdvancedAzureOverview';

const OverViewTabs = props => {
  const { cloudAccountData, updateData } = props;

  if (isEmpty(cloudAccountData)) return null;

  return (
    <div
      style={{
        padding: '20px 14px',
      }}
    >
      {cloudAccountData.provider === 'AWS' &&
        (cloudAccountData.protectionLevel === 'basic' ? (
          <BasicAWSOverview {...props} />
        ) : (
          <AdvancedAWSOverView {...props} />
        ))}

      {cloudAccountData.provider === 'AZURE' &&
        (cloudAccountData.protectionLevel === 'basic' ? (
          <BasicAzureOverview {...props} />
        ) : (
          <AdvancedAzureOverview {...props} />
        ))}

      {cloudAccountData.provider === 'GCP' &&
        (cloudAccountData.protectionLevel === 'basic' ? (
          <BasicGCPOverview {...props} />
        ) : (
          <AdvancedGCPOverview {...props} />
        ))}
    </div>
  );
};

export default OverViewTabs;
